import * as React from 'react';
import * as Classes from '../common/classes';
import { IProps, LayoutMode } from '../common/props';
import classNames from 'classnames';
import { ReactNode } from 'react';
import { SpaceSize } from '../space/Space';

export interface ILayoutProps extends IProps {
  /**
   * Standardně layout předpokládá, že je umístěn do parenta, který je display flex, pokud tomu tak není, je třeba nastavit h100 na true, aby se na výšku roztáhnul.
   */
  h100?: boolean;
  /**
   * Mezera mezi hlavičkou a tělem a patičkou a tělem, velikost není v pixelech ale logická, podobně jako mt-1.
   */
  spacing?: SpaceSize;
  header?: ReactNode;
  footer?: ReactNode;
  disableScroll?: boolean;
  mode?: LayoutMode;
  headerClassName?: string;
  footerClassName?: string;
  contentClassName?: string;
}

export type LayoutProps = ILayoutProps;

export const Layout: React.FC<LayoutProps> = ({
  className,
  header,
  footer,
  style,
  disableScroll,
  h100,
  spacing,
  children,
  headerClassName,
  contentClassName,
  footerClassName,
  mode = 'default',
}) => {
  return (
    <div
      className={classNames(className, Classes.LAYOUT, {
        [Classes.LAYOUT_DISABLE_SCROLL]: disableScroll,
        [Classes.LAYOUT_H100]: h100,
        [Classes.LAYOUT_DEFAULT]: mode === 'default',
        [Classes.LAYOUT_VIEW_DETAIL]: mode === 'viewDetail',
      })}
      style={style}
    >
      {header && (
        <div
          className={classNames(headerClassName, Classes.LAYOUT_HEADER, {
            [`mb-${spacing}`]: spacing,
          })}
        >
          {header}
        </div>
      )}
      <div className={classNames(contentClassName, Classes.LAYOUT_CONTENT)}>
        {children}
      </div>
      {footer && (
        <div
          className={classNames(footerClassName, Classes.LAYOUT_FOOTER, {
            [`mt-${spacing}`]: spacing,
          })}
        >
          {footer}
        </div>
      )}
    </div>
  );
};
